import React, { useState, useEffect } from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';

const RotatingGallery = () => {
  const { ref, animationClass } = useScrollAnimation('fade-in-up', 0.1);
  const [isAnimating, setIsAnimating] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  // Gallery images - these should match the PDF design
  const galleryImages = [
    { src: '/images/slider-lamp-1.jpg', alt: 'She holding the lamp' },
    { src: '/images/slider-lamp-2.jpg', alt: 'Lamp holds on a hand' },
    { src: '/images/slider-lamp-3.jpg', alt: 'Mishen holding the lamp' },
    { src: '/images/slider-lamp-4.jpg', alt: 'Text side of the lamp' },
    { src: '/images/slider-lamp-5.png', alt: 'Anoth holding the lamp' },
    { src: '/images/slider-lamp-6.jpg', alt: 'Anoth holding the lamp' },
    { src: '/images/slider-lamp-7.jpg', alt: 'Anoth holding the lamp' },
    { src: '/images/slider-lamp-8.jpg', alt: 'Anoth holding the lamp' },
  ];

  useEffect(() => {
    // Check if mobile on mount and resize
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024); // lg breakpoint
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    // Only animate on desktop
    let pauseInterval;
    if (!isMobile) {
      pauseInterval = setInterval(() => {
        setIsAnimating(false);
        setTimeout(() => {
          setIsAnimating(true);
        }, 2000); // 2 second pause
      }, 15000); // Pause every 15 seconds
    }

    return () => {
      window.removeEventListener('resize', checkMobile);
      if (pauseInterval) clearInterval(pauseInterval);
    };
  }, [isMobile]);

  return (
    <section ref={ref} className={`section-slider relative z-30 -mt-20 lg:-mt-40 ${animationClass}`}>
      <div className="slider-first-screen bg-[#FFF5F2] py-8 lg:py-16 overflow-hidden">
        <div className="relative">
          {/* Mobile: Scrollable container with touch support */}
          {isMobile ? (
            <div
              className="flex gap-3 overflow-x-auto snap-x snap-mandatory scrollbar-hide px-4"
              style={{
                WebkitOverflowScrolling: 'touch',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none'
              }}
            >
              {galleryImages.map((image, index) => (
                <div
                  key={index}
                  className="section-slider-item flex-shrink-0 w-64 h-80 sm:w-72 sm:h-96 rounded-lg overflow-hidden shadow-xl snap-center"
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-full object-cover"
                    loading="lazy"
                    onError={(e) => {
                      e.target.src = '/images/placeholder.jpg';
                    }}
                  />
                </div>
              ))}
            </div>
          ) : (
            /* Desktop: Auto-scrolling animation */
            <div
              className={`flex gap-6 ${isAnimating ? 'animate-gallery-scroll' : ''}`}
              style={{
                animationPlayState: isAnimating ? 'running' : 'paused',
              }}
            >
              {/* Double the images for seamless infinite scroll */}
              {[...galleryImages, ...galleryImages].map((image, index) => (
                <div
                  key={index}
                  className="section-slider-item flex-shrink-0 w-80 h-96 rounded-lg overflow-hidden shadow-xl"
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                    onError={(e) => {
                      e.target.src = '/images/placeholder.jpg';
                    }}
                  />
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Scroll indicator for mobile */}
        {isMobile && (
          <div className="text-center mt-4">
            <p className="text-xs text-gray-500 animate-pulse">← Swipe to see more →</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default RotatingGallery;
